import camelize from 'camelize';
import { baseCreateApi } from 'services';

export const ticketingApi = baseCreateApi.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    getTicketingProviderSettings: builder.query({
      query: ({ providerUuid }) => ({
        url: `/api/v1/ticketingproviders/ticketing_provider_settings/?provider=${providerUuid}`,
        method: 'GET'
      }),
      transformResponse: camelize
    }),
    // Workspaces
    getTicketingTeams: builder.query({
      query: ({ providerUuid }) => ({
        url: `/api/v1/ticketingproviders/ticketing_teams/?provider=${providerUuid}`,
        method: 'GET'
      }),
      transformResponse: camelize
    }),
    // Spaces lists for that workspace
    getTicketingList: builder.query({
      query: ({ providerUuid, workspaceUuid }) => ({
        url: `/api/v1/ticketingproviders/${workspaceUuid}/ticketing_team_list_config/?provider=${providerUuid}`,
        method: 'GET'
      }),
      transformResponse: camelize
    }),
    // Get task templates for that workspace
    getTicketingTaskTemplates: builder.query({
      query: ({ providerUuid, workspaceUuid }) => ({
        url: `/api/v1/ticketingproviders/${workspaceUuid}/ticketing_team_task_templates/?provider=${providerUuid}`,
        method: 'GET'
      }),
      transformResponse: camelize
    }),
    createManualTicket: builder.mutation({
      query: ({ payload, providerUuid }) => ({
        url: `/api/v1/ticket/?provider=${providerUuid}`,
        method: 'POST',
        data: payload
      }),
      transformResponse: camelize
    }),
    syncChannels: builder.mutation({
      query: ({ providerUuid }) => ({
        url: `/api/v1/ticketingproviders/sync_configuration_data/?provider=${providerUuid}`,
        method: 'POST'
      }),
      transformResponse: camelize
    }),
    // Get task preferences for that meeting
    getTicketingTaskPreference: builder.query({
      providesTags: ['ticketingTaskPreference'],
      query: ({ meetingUuid }) => ({
        url: `/api/v2/meetings/${meetingUuid}/task_preference/`,
        method: 'GET'
      }),
      transformResponse: camelize
    }),
    // Using API url that comes from the BE to hit members for CRM
    getTicketingCrmMembers: builder.query({
      query: ({ url }) => ({
        url: `/api/v1/${url}`,
        method: 'GET'
      }),
      transformResponse: camelize
    })
  })
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTicketingListQuery,
  useGetTicketingProviderSettingsQuery,
  useGetTicketingTeamsQuery,
  useCreateManualTicketMutation,
  useSyncChannelsMutation,
  useGetTicketingTaskTemplatesQuery,
  useGetTicketingTaskPreferenceQuery,
  useGetTicketingCrmMembersQuery
} = ticketingApi;
